<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>A Tax in Blood</span></p>
<p class="bk-title1"><span>A Leo Haggerty Mystery</span></p>
<p class="authorname"><span>Benjamin M. Schutz</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_02.jpg"/></span></p>
<p class="publisher1"><span>MYSTERIOUSPRESS.COM</span></p>
<p class="publisher2"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?69f97570